import { css } from 'styled-components';

export default css`
  height: 100%;
`;
